export const getContrastYIQ = (hc: string) => {
  const [r, g, b] = [0, 2, 4].map(p => parseInt(hc.substring(p, p + 2), 16));
  return (r * 299 + g * 587 + b * 114) / 1000 >= 128;
};

export const getContrastColor = (backgroundColorHexcode: string) => {
  const hexcode = backgroundColorHexcode.replace(/^#/, '');
  const contrast = getContrastYIQ(hexcode);
  return contrast ? 'black' : 'white';
};
